(function () {
  if (!('IntersectionObserver' in window)) return;
  var videos = document.querySelectorAll('.listicle-lazy-video');
  if (!videos.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var video = entry.target;
      if (entry.isIntersecting) {
        if (video.readyState < 2) video.load();
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });
  }, { rootMargin: '120px', threshold: 0.25 });
  videos.forEach(function (video) {
    observer.observe(video);
  });
})();
